import { Box } from "@mui/material";
import RHFSelect from "src/shared/components/form-fields/RHF-select";
import type { ReactNode } from "react";

const CarWashType = ({
  types,
}: {
  types: {
    label: ReactNode;
    value: string;
  }[];
}) => {
  return (
    <Box mt={"30px"}>
      <RHFSelect
        name="serviceName"
        label="selectRequiredService"
        options={types}
      />
    </Box>
  );
};

export default CarWashType;
